<!-- <template>
    <div>
      <el-upload
        name="file"
        class="avatar-uploader"
        :show-file-list="true"
        :headers="{'Authorization': 'Bearer ' + idTokenGetter}"
        action="https://p5afw4zfc3.execute-api.ap-southeast-1.amazonaws.com/prod/api/upload"
        :on-preview="handlePreview"
        :on-change="success"
        :accept="acceptType()"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :limit="fileLimit"
        :file-list="fileListAnswer">
        <img v-if="imgUrlGetter" :src="cdnGetter + imgUrlGetter" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
  </template> -->
  <template>
    <el-upload
      name="file"
      class="avatar-uploader"
      :show-file-list="false"
      :headers="{ 'Authorization': 'Bearer ' + idTokenGetter }"
      action="https://p5afw4zfc3.execute-api.ap-southeast-1.amazonaws.com/prod/api/upload"
      :on-change="handleSuccess"
      :before-upload="compressBeforeUpload"
      :accept="acceptType()"
      :limit="10"
      multiple>
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import Compressor from 'compressorjs'

export default {
  computed: {
    ...mapGetters(['idTokenGetter', 'imgUrlGetter', 'cdnGetter'])
  },
  data () {
    return {
      disabled: false,
      fileListAnswer: [],
      fileList: [],
      isShow: false,
      fileTitle: '',
      fileTitleAnswer: 'Та хариултын файлыг хуулна уу',
      fileLimit: 1,
      compressOptions: {
        quality: 0.5, // 30% чанар (маш хүчтэй шахалт)
        maxWidth: 1280, // Илүү жижигрүүлэх
        maxHeight: 720, // HD resolution хүртэл
        convertSize: 0, // Бүх файлыг шахах
        convertTypes: ['image/png', 'image/jpeg'], // Бүх төрлийг JPEG болгох
        mimeType: 'image/jpeg' // Гаралтыг JPEG-рүү хүчлэн хөрвүүлэх
      }
    }
  },
  methods: {
    ...mapActions(['setDynamicImgUrl']), // Vuex actions ашиглах
    compressBeforeUpload (file) {
      return new Promise((resolve, reject) => {
        if (file.type.includes('image')) {
          // eslint-disable-next-line no-new
          new Compressor(file, {
            ...this.compressOptions,
            success (result) {
              resolve(new File([result], file.name, {
                type: result.type,
                lastModified: Date.now()
              }))
            },
            error (err) {
              console.error('Image compression error:', err)
              reject(err)
            }
          })
        } else {
          resolve(file)
        }
      })
    },
    handleSuccess (file, fileList) {
      if (file.response && file.response.data && file.response.data.location) {
        const imageUrl = file.response.data.location
        this.$emit('uploaded', imageUrl) // 🎯 parent рүү emit хийж байна
      }
    },
    success (file, fileList) {
      this.$root.fullScreenLoading = true
      if (file.response) {
        this.setDynamicImgUrl(file.response.data.location)
        this.$root.fullScreenLoading = false
      }
      setTimeout(() => {
        this.isShow = true
        this.$root.fullScreenLoading = false
      }, 10000)
    },
    acceptType () {
      return 'image/png, image/jpeg'
    },
    async handleRemove (file, fileList) {
      let response = file.url.split('?')[0]
      response = response.split('.com/')[1]
      file.response = response
      try {
        const response = await axios.post('https://p5afw4zfc3.execute-api.ap-southeast-1.amazonaws.com/prod/api/upload', {
          bucketName: 'dmafilemanagement',
          fileName: file.response
        })

        console.log('Устгах хүсэлтийн хариу:', response.data)

        this.setDynamicImgUrl(null)
        this.isShow = false
      } catch (error) {
        console.error('Зураг устгах үед алдаа гарлаа:', error)
      }
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`Сонгосон  ${file.name}  файлыг хавсаргасан файлын жагсаалтаас хасах уу?`)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(
          `Файл тоо хэтэрсэн байна. ${files.length} файл хуулсан байна. ${this.fileLimit} хэтрэхгүй файл хуулна уу.`
      )
    },
    handleUploadVariantfulImages (file, fileList) {
      this.fileList = fileList
    }
  }
}
</script>

  <style>
  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
  </style>
